import { render, staticRenderFns } from "./user-wizard-error-display.vue?vue&type=template&id=164d12a5"
import script from "./user-wizard-error-display.vue?vue&type=script&lang=js"
export * from "./user-wizard-error-display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports